export default {
  data () {},
  methods: {
    getStatusColor (status) {
      if (status === 'open') return 'warning'
      if (status === 'completed') return 'success'
      if (status === 'failed') return 'danger'
      return 'success'
    },
  }
}
